// extracted by mini-css-extract-plugin
var _1 = "bg-TPGVm";
var _2 = "club-YeV5y";
var _3 = "confirm-UXpTC";
var _4 = "list-V7nQL";
var _5 = "shad-fBPvh";
var _6 = "text-D7cg1";
var _7 = "title-n3hGq";
export { _1 as "bg", _2 as "club", _3 as "confirm", _4 as "list", _5 as "shad", _6 as "text", _7 as "title" }
